import type { ComponentProps } from './types'

export const FormsDivider = (_props: ComponentProps) => {
	return <div className='w-full flex flex-col h-px bg-neutral-400 my-6' />
}
